module.exports = "https://referendum2020-campaigns-cdn.fire-emblem-heroes.com/images/116.d512f00b.png";